// extracted by mini-css-extract-plugin
export default {"placeMiniCharacter":"PlaceMiniView_placeMiniCharacter__7igNg"};